/// <reference types="vite/client" />
import.meta.glob(['../images/**', '../fonts/**']);
import alpine from 'alpinejs';
function scrollCarousel(selector, direction) {
  const container = document.querySelector(selector);
  if (!container) return;

  const items = container.children;
  if (!items.length) return;
  console.log(typeof items);

  const galleryItems = Array.from(items).filter(i => !i.classList.contains('hidden'));

  if (!galleryItems.length) return;

  const itemWidth = galleryItems[0].offsetWidth;

  const scrollAmount = itemWidth * direction;

  container.scrollBy({
    left: scrollAmount,
    behavior: 'smooth',
  });
}

Object.assign(window, { Alpine: alpine, scrollCarousel: scrollCarousel }).Alpine.start();
